/**
 * @generated SignedSource<<f80a1b649d30ab05d5023597b2fb7097>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FavouritesMenuSection$data = {
  readonly favourites: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"FavouriteLink_node">;
        } | null;
      } | null;
    }>;
  } | null;
  readonly " $fragmentType": "FavouritesMenuSection";
};
export type FavouritesMenuSection$key = {
  readonly " $data"?: FavouritesMenuSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavouritesMenuSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "favourites"
        ]
      }
    ]
  },
  "name": "FavouritesMenuSection",
  "selections": [
    {
      "alias": "favourites",
      "args": null,
      "concreteType": "MemberFavouriteConnection",
      "kind": "LinkedField",
      "name": "__FavouritesContent_favourites_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberFavouriteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MemberFavourite",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "FavouriteLink_node"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SessionInfo",
  "abstractKey": null
};

(node as any).hash = "8d48aae34c05d6c9bf194a69b78439d7";

export default node;
